import { forwardRef, type SVGProps } from 'react';

export const NoteSuccessIcon = forwardRef<
  SVGSVGElement,
  SVGProps<SVGSVGElement>
>(function NoteSuccessIcon(props, ref) {
  return (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M4.587 21.412C4.979 21.804 5.45 22 6 22H18C18.5493 22.0007 19.02 21.805 19.412 21.413C19.804 21.021 20 20.55 20 20V8L14 2H6C5.45067 1.99934 4.98 2.195 4.588 2.587C4.196 2.979 4 3.45 4 4V20C3.99934 20.5493 4.195 21.02 4.587 21.412ZM18 9H13V4L18 9ZM10.3221 17.3033C10.3775 17.3233 10.4368 17.3333 10.5002 17.3333C10.5635 17.3333 10.6229 17.3233 10.6783 17.3033C10.7337 17.2835 10.7852 17.2498 10.8327 17.2021L15.2027 12.8113C15.2898 12.7238 15.3333 12.6104 15.3333 12.4711C15.3333 12.332 15.2898 12.2187 15.2027 12.1312C15.1156 12.0438 15.0029 12 14.8645 12C14.7258 12 14.6129 12.0438 14.5258 12.1312L10.5002 16.176L8.80204 14.4698C8.71496 14.3823 8.60413 14.3386 8.46954 14.3386C8.33496 14.3386 8.22412 14.3823 8.13704 14.4698C8.04996 14.5573 8.00436 14.6706 8.00024 14.8096C7.99644 14.949 8.03808 15.0624 8.12517 15.1499L10.1677 17.2021C10.2152 17.2498 10.2666 17.2835 10.3221 17.3033Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
});
